/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The visibility of the package version
 */
export const PublishPackageFormVisibility = {
  Public: "public",
  Private: "private",
} as const;
/**
 * The visibility of the package version
 */
export type PublishPackageFormVisibility = ClosedEnum<
  typeof PublishPackageFormVisibility
>;

export type PublishPackageForm = {
  /**
   * The deployment ID to associate with the package version
   */
  deploymentId: string;
  /**
   * The name of the package
   */
  name: string;
  /**
   * The new semantic version of the package to publish
   */
  version: string;
  /**
   * The visibility of the package version
   */
  visibility: PublishPackageFormVisibility;
};

/** @internal */
export const PublishPackageFormVisibility$outboundSchema: z.ZodMiniEnum<
  typeof PublishPackageFormVisibility
> = z.enum(PublishPackageFormVisibility);

/** @internal */
export type PublishPackageForm$Outbound = {
  deployment_id: string;
  name: string;
  version: string;
  visibility: string;
};

/** @internal */
export const PublishPackageForm$outboundSchema: z.ZodMiniType<
  PublishPackageForm$Outbound,
  PublishPackageForm
> = z.pipe(
  z.object({
    deploymentId: z.string(),
    name: z.string(),
    version: z.string(),
    visibility: PublishPackageFormVisibility$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      deploymentId: "deployment_id",
    });
  }),
);

export function publishPackageFormToJSON(
  publishPackageForm: PublishPackageForm,
): string {
  return JSON.stringify(
    PublishPackageForm$outboundSchema.parse(publishPackageForm),
  );
}
